import { FC } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { toggleVideoFavorite, toggleVideoWatched } from 'api/videos';
import { Card, Checkbox, FormControlLabel, IconButton } from '@mui/material';
import Header from 'components/Header/Header';
import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';

type Props = {
    /**
     * Идентификатор видео.
     */
    id: string;

    /**
     * Тема видео.
     */
    title: string;

    /**
     * Флаг просмотра видео.
     */
    watched: boolean;

    /**
     * Автор видео.
     */
    authors: [string];

    /**
     * Рейтинг видео текущего пользователя.
     */
    user_rating: number;

    /**
     * Общий рейтинг видео.
     */
    avg_rating: number;

    /**
     * Дата видео.
     */
    recorded_date: string;

    /**
     * Функция для возврата назад.
     */
    resetVideo: () => void;

    /**
     * Избранное
     */
    favorite: boolean;
};

const PlaybackHeader: FC<Props> = ({ id, title, watched, authors, user_rating, avg_rating, recorded_date, resetVideo, favorite }) => {
    const queryClient = useQueryClient();

    const videoWatchedMutation = useMutation(toggleVideoWatched, {
        onSuccess: () => {
            queryClient.invalidateQueries('videos');
            queryClient.invalidateQueries('videos-watch');
        },
    });

    const videoFavoriteMutation = useMutation(toggleVideoFavorite, {
        onSuccess: () => {
            queryClient.invalidateQueries('videos');
            queryClient.invalidateQueries('videos-watch');
        },
    });

    // const rateVideoMutation = useMutation(rateVideo, {
    //     onSuccess: () => {
    //         queryClient.invalidateQueries('videos');
    //         queryClient.invalidateQueries('videos-watch');
    //     },
    // });

    // const onRateVideo = (val: number) => {
    //     rateVideoMutation.mutate({ id: id, rating: val / 20 });
    // };

    const toggleWatched = async () => {
        videoWatchedMutation.mutate(id);
    };

    const toggleFavorite = async () => {
        videoFavoriteMutation.mutate(id);
    };

    return (
        <>
            <Header title={title} back={resetVideo} />
            <Card variant="outlined" className="flex flex-col sm:flex-row sm:items-center sm:justify-between p-4 gap-4">
                <div className="flex items-center gap-4">
                    <IconButton onClick={toggleFavorite} size="small">
                        {favorite ? (
                            <FavoriteIcon className="text-red-500" fontSize="medium" />
                        ) : (
                            <FavoriteBorderIcon className="text-gray-400" fontSize="medium" />
                        )}
                    </IconButton>

                    <FormControlLabel control={<Checkbox checked={watched} onChange={toggleWatched} size="small" />} label="Просмотрено" />
                </div>

                <div className="flex flex-col sm:items-end text-sm text-gray-700 gap-1">
                    <span className="text-gray-800 font-medium  py-1 rounded">Автор(ы): {authors.join(', ')}</span>
                    <span className="text-xs text-gray-500">{recorded_date}</span>
                </div>
            </Card>
        </>
    );
};

export default PlaybackHeader;
